import { render } from "./SelectCategory.vue?vue&type=template&id=6d06f8ea&scoped=true"
import script from "./SelectCategory.vue?vue&type=script&lang=js"
export * from "./SelectCategory.vue?vue&type=script&lang=js"

import "./SelectCategory.vue?vue&type=style&index=0&id=6d06f8ea&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d06f8ea"]])

export default __exports__